// Absolute-timestamp sleep (background tabs throttle setTimeout, so we loop and
// check Date.now() instead of trusting a single long timeout). Abortable.
export function sleep(ms: number, signal?: AbortSignal): Promise<void> {
  const end = Date.now() + ms;
  return new Promise<void>((resolve, reject) => {
    const tick = () => {
      if (signal?.aborted) {
        reject(new DOMException("aborted", "AbortError"));
        return;
      }
      const remaining = end - Date.now();
      if (remaining <= 0) {
        resolve();
        return;
      }
      setTimeout(tick, Math.min(remaining, 1000));
    };
    tick();
  });
}

export function jitterDelayMs(minS: number, maxS: number, rnd: () => number = Math.random): number {
  const lo = Math.min(minS, maxS);
  const hi = Math.max(minS, maxS);
  return Math.round((lo + rnd() * (hi - lo)) * 1000);
}

/** Tracks sends since the last long pause to implement "pause every N". */
export class LongPauseTracker {
  private count = 0;
  constructor(
    private everyN: number | null | undefined,
    private pauseSecs: number | null | undefined,
  ) {}

  /** Returns ms to pause now (0 if none due). Call after each successful send. */
  tick(): number {
    if (!this.everyN || !this.pauseSecs) return 0;
    this.count++;
    if (this.count >= this.everyN) {
      this.count = 0;
      return this.pauseSecs * 1000;
    }
    return 0;
  }
}
